import React, { useEffect, useContext, useState, useCallback } from 'react';
import { PageContext } from '../page';
import { useSelector } from 'react-redux';
import FeedbackModalContainer from '../feedbackModalContainer';
import Modal from '../../../components/modal';
import Omnisearch from '../omniSearch';
import { maybeDispalyUpdateEmailMessage } from '../../../configTdm';
import { getHelpPage, getProperty } from '../../../fsConfig';
import { SUPPORT_EMAIL, SUPPORT_LINK } from '../../../constants';
import { performLogout } from '../../../utils/logoutUtils';

const Header: React.FC = () => {
  const { HelpPageComponent, title, helperFlag, supportFlag } = useContext(PageContext);
  const user = getProperty('session', {});
  const helpPage = useSelector(getHelpPage);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const { multiTabView } = user;

  useEffect(() => {
    maybeDispalyUpdateEmailMessage(user);
  }, [user]);

  const closeFeedbackModal = useCallback(() => setShowFeedbackModal(false), []);
  const closeHelpModal = useCallback(() => setShowHelpModal(false), []);

  return (
    <>
      <FeedbackModalContainer
        showModal={showFeedbackModal}
        closeModal={closeFeedbackModal}
      />
      {!!HelpPageComponent && (
        <Modal
          isOpen={showHelpModal}
          onClose={closeHelpModal}
          title={`${title} Help`}
          size="large"
        >
          <HelpPageComponent />
        </Modal>
      )}
      <header>
        <div className="row">
          <div className="col-md-12">
            <div className="col-xs-12 col-sm-5 col-md-4 col-lg-4 branding">
              <a href="/home" className="logo"></a>
            </div>
            {multiTabView && <Omnisearch />}
            <div className="col-sm-4 col-md-3 col-lg-3 hidden-xs controls pull-right">
              <div>
                <span>
                  Welcome
                  <a href="/settings">{` ${user.name} `}</a>
                  {user && user.suUsername && (
                    <span className="su">({user.suUsername})</span>
                  )}
                </span>
              </div>
              <div>
                <ul>
                  <li>
                    <a href="/settings">Settings</a> |{' '}
                  </li>
                  <li>
                    <a href="#" onClick={(e) => { e.preventDefault(); performLogout(); }}>Logout</a> |{' '}
                  </li>
                  {helperFlag ? (
                    <li>
                      <a href={helpPage} target="_blank">
                        Help
                      </a>{' '}
                      |{' '}
                    </li>
                  ) : (
                    <>
                      {!!HelpPageComponent && (
                        <li>
                          <a
                            onClick={() => {
                              setShowHelpModal(true);
                            }}
                          >
                            Help
                          </a>{' '}
                          |{' '}
                        </li>
                      )}
                    </>
                  )}
                  {supportFlag ? 
                    <li
                      className="support-link"
                      data-title={`Send email to ${SUPPORT_EMAIL}. Click here for options.`}
                    >
                      <a
                        onClick={() => {
                          window.location.href = `mailto:${SUPPORT_EMAIL}`;
                        }}
                      >
                        Support
                      </a>
                    </li> : <li className="support-link">
                      <a href={SUPPORT_LINK} target="_blank">
                        Support
                      </a>
                    </li>}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};


export default Header;